<template>
  <div class="personal-data">

    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'#2F1F4C'"
        @clickBack="clickBack"
        @clickMenu="clickMenu"
    />

    <div class="personal-data__title">
      Обработка персональных данных
    </div>

    <div class="personal-data__descr">
      Заказчик подтверждает свое согласие с тем, что:<br>
        1.1. Регистрационные данные (в том числе персональные данные) указаны им добровольно;<br>
        1.2. Регистрационные данные (в том числе персональные данные) передаются в электронной форме по открытым каналам связи сети «Интернет»;<br>
        1.3. Регистрационные данные (в том числе персональные данные) переданы Владельцу сайта для реализации целей,
          указанных в настоящем Пользовательском соглашении и в этих же целях могут быть переданы третьим лицам;<br>
        1.4. Регистрационные данные (в том числе персональные данные) могут быть использованы Владельцем сайта
          в целях продвижения товаров и услуг, путем осуществления прямых контактов с Заказчиком с помощью каналов связи;<br>
        1.5. Регистрационные данные (в том числе персональные данные) могут быть использованы Владельцем сайта в целях
          направления Заказчику рекламы и информации по сетям электросвязи, в том числе через Интернет, в соответствии со ст.18 Ф3 «О рекламе» от 13.03.2006 г.;<br>
        1.6. В целях дополнительной защиты от мошеннических действий указанные Заказчиком регистрационные данные (в том числе персональные данные)
          могут быть переданы банку, осуществляющему транзакции по оплате оформленных на Сайте заказа поздравлений Заказов;<br>
        1.7. Данное Заказчиком согласие на обработку его регистрационных данных (в том числе персональных данных) является
      бессрочным и может быть отозвано Заказчиком или его законным представителем, подачей письменного заявления, переданного Владельцу сайта.
    </div>

    <div class="personal-data__descr">
      Владелец сайта обязуется:<br>
        1.8. Обрабатывать персональные данные Заказчика в порядке, установленном действующим законодательством и Правилами настоящего
          Пользовательского соглашения в отношении организации обработки и обеспечения безопасности персональных данных.<br>
        1.9. В случае отзыва Заказчика согласия на обработку его персональных данных Владелец сайта обязуется прекратить их
          обработку или обеспечить прекращение такой обработки (если обработка персональных данных осуществляется другим лицом,
        действующим по поручению Владельца сайта) и в случае, если сохранение персональных данных более не требуется для целей
        обработки персональных данных, уничтожить персональные данные или обеспечить их уничтожение (если обработка персональных
        данных осуществляется другим лицом, действующим по поручению Владельца сайта) в срок, не превышающий тридцати дней с даты
        поступления указанного отзыва, если иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем
        по которому является Заказчик.
    </div>

    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="clickLink"
          @clickOutside="clickLink"
      />
    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>

  </div>
</template>

<script>

const AppHeader = () => import('~/components/header.vue')
const AppMenu = () => import('~/components/menu.vue')
const AppOverlay = () => import('~/components/overlay.vue')

export default {
  data() {
    return {
      menu: false,
      overlay: false
    }
  },
  methods: {
    async clickBack() {
      this.$router.back()
    },
    async clickMenu() {
      this.overlay = true
      this.menu = true
    },
    async clickLink() {
      this.menu = false
      this.overlay = false
    }
  },
  components: {
    AppHeader,
    AppMenu,
    AppOverlay
  }
}
</script>

<style lang="less">

  @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

  .personal-data {
    background-color: #2F1F4C;
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
    user-select: text;
  }

  .personal-data__title {
    font-size: 20px;
    line-height: 20px;
    font-family: 'Montserrat-Bold';
    color: #FFFFFF;
    text-align: center;
    margin-top: 64px;
    margin-bottom: 32px;
    width: 100%;
    padding: 0px 20px;
    font-size: 20px;
  }

  @import '~/assets/fonts/montserrat/Montserrat-Light.less';

  .personal-data__descr {
    max-width: 1000px;
    font-size: 16px;
    font-family: 'Montserrat-Light';
    padding: 0px 30px;
    color: #FFFFFF;
    line-height: 22px;
    margin-bottom: 20px;
  }
</style>